import { colors } from '@noths/polaris-client-ribbons-design-system';
import {
  maxBreakpoints,
  mediaQuery,
  minBreakpoints,
  pxToRem,
  shadowUp,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: ${pxToRem(spacing.xxl)} 0 ${pxToRem(80)};

  ${mediaQuery(
    {
      max: maxBreakpoints.MEDIUM,
    },
    css`
      margin-top: ${pxToRem(spacing.md)};
    `,
  )}
`;

export const breadcrumbContainer = css`
  grid-column: 1 / -1;

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / -2;
    `,
  )}
`;

export const recommendedProductsContainer = css`
  &[data-hide-placement='true'] {
    margin-bottom: ${pxToRem(spacing.md)};

    ${mediaQuery(
      { min: minBreakpoints.LARGE },
      css`
        margin-bottom: ${pxToRem(spacing.xxxxl)};
      `,
    )}
  }
`;

/*
  Active products placement needs additional margin vs the other placements due to partner storefront spacing/negative
  margins.
*/
export const activeProductsContainer = css`
  margin-bottom: ${pxToRem(spacing.xxxxl + spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      margin-bottom: ${pxToRem(spacing.xxxxl)};
    `,
  )}

  &[data-hide-placement='true'] {
    margin-bottom: ${pxToRem(spacing.xxxxl + spacing.md)};

    ${mediaQuery(
      { min: minBreakpoints.LARGE },
      css`
        margin-bottom: ${pxToRem(spacing.xxxxl * 2 + 4)};
      `,
    )}
  }
`;

export const recommendationCarousel = css`
  grid-column: span 12;
  padding-bottom: ${pxToRem(42)};
  border-bottom: ${pxToRem(1)} solid ${colors.neutralLight};

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      margin-bottom: ${pxToRem(80)};
      grid-column: 2 / -2;
    `,
  )}
`;

export const productReviewsOuterWrapper = css`
  margin-top: ${pxToRem(spacing.xxl)};

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      margin-top: ${pxToRem(spacing.xxxxl)};
    `,
  )}
`;

export const linkCarouselWrapper = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / -2;
    `,
  )}
`;

export const productDescriptionWrapper = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / -2;
    `,
  )}
`;

export const productReviewsWrapper = css`
  min-width: 0;
  grid-column: 1 / -1;
  grid-row: 2;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-row: 1;
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / span 7;
    `,
  )}
`;

export const overallRatingWrapper = css`
  grid-row: 1;
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 9 / span 3;
    `,
  )}
`;

export const productDescriptionContainer = css`
  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      ${shadowUp};
    `,
  )};
`;

export const imagesContainer = css`
  ${/* min-width needed to fix bug in firefox where grid item overflows */ ''}
  min-width: 0;
  grid-column: 1 / -1;

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      position: sticky;
      top: 0;
      z-index: -1;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / span 7;
    `,
  )}
`;

export const productInfoContainer = css`
  grid-column: 1 / -1;
  z-index: 2;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 9 / span 3;
    `,
  )}
`;

export const imagesAndInfoWrapper = css`
  ${/* Note: This line below creates a new stacking context to ensure that the product info is on top of 
       the product carousel when trying to achieve a parralax effect with fixed positioning. This new stacking
       context here however means we cannot have fixed positioned elements inside the product info organism */ ''}
  isolation: isolate;

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      row-gap: 0;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      margin-bottom: ${pxToRem(spacing.xxl)};
    `,
  )}
`;

export const storefrontWrapper = css`
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background-color: ${colors.neutralLighter};
  margin-bottom: ${pxToRem(48)};

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      margin-bottom: ${pxToRem(176)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      margin-bottom: ${pxToRem(212)};
    `,
  )}
`;
